module.exports = __webpack_public_path__ + "static/img/mapa_cat.07ec364.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/mapa_cat.png
// module id = +BR9
// module chunks = 1